import React from 'react';
import './PlanLimitDrawer.css';
import closeIcon from '../../assets/close-icon.png';
import { useNavigate } from 'react-router-dom';

export default function PlanLimitDrawer({
  open,
  onClose,
  limit = 300,
  planLabel = 'Free',
  featureLabel = 'Post length',
  ctaLabel = 'Upgrade Plan',
  unit = 'characters', // supports images, videos, etc.
  message = '', // ✅ NEW: optional custom message (e.g. "Editing posts is not available…")
}) {
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <div className="bf-sheet-backdrop" onClick={onClose}>
      <div className="bf-sheet" onClick={(e) => e.stopPropagation()}>
        <img
          src={closeIcon}
          alt="Close"
          className="bf-sheet-close"
          onClick={onClose}
        />

        <div className="bf-sheet-title">Limit reached</div>

        <div className="bf-sheet-subtitle">
          {message ? (
            <>
              You’re on <b>{planLabel}</b>. {message}
            </>
          ) : (
            <>
              You’re on <b>{planLabel}</b>. {featureLabel} is limited to{' '}
              <b>{limit}</b> {unit}.
            </>
          )}
        </div>

        <div className="bf-sheet-hint">
          Upgrade to unlock more features and higher limits.
        </div>

        <button
          className="bf-sheet-cta"
          onClick={() => {
            onClose?.();
            navigate('/plans');
          }}
        >
          {ctaLabel}
        </button>
      </div>
    </div>
  );
}
